import React, { Component } from 'react';

import Body from './body';

export default class SingleTargetApp extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <p>
                    <b><a href='https://github.com/jchristman/react-context-menus/tree/master/examples/02%20Dynamic%20Menus/Stress%20Test'>Browse the Source</a></b>
                </p>
                <p>
                    This example not yet built.
                </p>
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./examples/02 Dynamic Menus/Stress Test/index.js
 **/